var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99997 10C5.99997 10.2981 6.14919 10.5963 6.29841 10.7453L11.2228 15.6646C11.6704 16.1118 12.4165 16.1118 12.8642 15.6646C13.3119 15.2174 13.3119 14.472 12.8642 14.0248L8.8352 10L12.8642 5.97516C13.3119 5.52795 13.3119 4.78261 12.8642 4.3354C12.4165 3.8882 11.6704 3.8882 11.2228 4.3354L6.44764 9.10559C6.14919 9.40373 5.99997 9.70186 5.99997 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevronLeft.e7936059116a5599f4745c555aff0754.svg";
export { ForwardRef as ReactComponent };